import React from 'react';
import PropTypes from 'prop-types';
import {
  Badge,
  Col,
  Row,
} from 'reactstrap';
import {
  Field,
} from 'redux-form';
import TextBox from '../../../../shared/components/form/TextBox';

const HorariosTable = ({
  items = [],
  profesores = [],
  codigoClassroom = '',
  onChangeText,
  materiaPeriodo = {},
  esAlumno = false,
}) => {
  const format = escalafon => (
    <h4 key={`prof_${escalafon.value}`} style={{ display: 'flex' }}>
      <Badge
        key={`prof_${escalafon.value}`}
        color={escalafon.value === 0 ? 'secondary' : 'primary'}
      >
        {escalafon.value === 0 ? '' : 'Prof. '}{escalafon.label}
      </Badge>
    </h4>
  );

  const { preRequisitos = [] } = materiaPeriodo;
  const horasSemanales = [
    {
      name: <>TE&Oacute;RICAS: Hs.</>, value: materiaPeriodo.horasTeoriaSemanal,
    },
    { name: <>PR&Aacute; CTICAS: Hs.</>, value: materiaPeriodo.horasPracticaSemanal },
    { name: <>LABORATORIO. Hs.</>, value: materiaPeriodo.horasLaboratorioSemanal },
    { name: <>TOTAL:</>, value: materiaPeriodo.totalHorasSemanal },
  ];

  return (
    <div className="table-wrapper" style={{ marginBottom: '20px', overflowX: 'auto' }}>
      <Row>
        <Col lg={6} md={6} lx={12}>
          <table className="table table-striped check-in" style={{ marginBottom: '20px', overflowX: 'auto' }}>
            <thead>
              <tr>
                <th className="col col-5">DOCENTES</th>
                <th className="col col-3">CATEGOR&Iacute;A</th>
              </tr>
            </thead>
            <tbody>
              {profesores.map(({
                id,
                profesor,
                escalafon,
              }, index) => (
                <tr key={`tr_${id}`} id={`tr_${id}`}>
                  <th className="col col-5">
                    <div className="form" style={{ display: 'flex' }}>
                      <span>{`${index + 1}.- ${profesor}`}</span>
                    </div>
                  </th>
                  <th className="col col-5">
                    <div className="form" style={{ display: 'flex' }}>
                      <span>{format(escalafon)}</span>
                    </div>
                  </th>
                </tr>
              ))}
            </tbody>
          </table>
        </Col>
        <Col lg={6} md={6} lx={12}>
          <table className="table table-striped check-in" style={{ marginBottom: '20px', overflowX: 'auto' }}>
            <thead>
              <tr>
                <th colSpan="2" className="col col-12 text-center">HORAS SEMANALES:</th>
              </tr>
            </thead>
            <tbody>
              {horasSemanales.map(({
                name,
                value,
              }, index) => (
                <tr key={`tr-${value}-${index + 1}`} id={`tr-${value}-${index}`}>
                  <th className="col col-6">
                    <div className="form" style={{ display: 'flex' }}>
                      <span>{name}</span>
                    </div>
                  </th>
                  <th className="col col-6">
                    <div className="form" style={{ display: 'flex' }}>
                      <span>{value}</span>
                    </div>
                  </th>
                </tr>
              ))}
            </tbody>
          </table>
        </Col>
        <Col lg={6} md={6} lx={12}>
          <table className="table table-striped check-in" style={{ marginBottom: '20px', overflowX: 'auto' }}>
            <thead>
              <tr>
                <th className="col col-3"><span>HORARIO DE CLASES: </span></th>
                <th className="col col-2"><span>D&Iacute;A/HORA</span></th>
              </tr>
            </thead>
            <tbody>
              {items.map(({
                id,
                dia,
                tipoActividadAcademicaHorario,
                horaInicio,
                horaFin,
              }) => (
                <tr key={`tr_${id}`} id={`tr_${id}`}>
                  <th className="col col-3">
                    <div className="form" style={{ display: 'flex' }}>
                      <span>{tipoActividadAcademicaHorario.label}</span>
                    </div>
                  </th>
                  <th className="col col-2">
                    <div className="form" style={{ display: 'flex' }}>
                      <span>{dia.label}: {horaInicio}-{horaFin}</span>
                    </div>
                  </th>
                </tr>
              ))}
            </tbody>
          </table>
        </Col>
        <Col lg={6} md={6} lx={12}>
          <table className="table table-striped check-in" style={{ marginBottom: '20px', overflowX: 'auto' }}>
            <thead>
              <tr>
                {
                  esAlumno || !materiaPeriodo.canEditarPlaneamiento ? (
                    <th className="col col-12 text-center">
                      <div style={{ display: 'flex', gap: '0.5rem' }}>
                        <span>CODIGO DEL CLASSROOM: </span>
                        <span>{codigoClassroom}</span>
                      </div>
                    </th>
                  ) : (
                    <th>
                      <div className="form__form-group" style={{ marginBottom: '20px' }}>
                        <span className="form__form-group-label">CODIGO DEL CLASSROOM:</span>
                        <div className="form__form-group-field">
                          <Field
                            name="codigoClassroom"
                            component={TextBox}
                            type="text"
                            disabled={!materiaPeriodo.canEditarPlaneamiento}
                            readOnly={!materiaPeriodo.canEditarPlaneamiento}
                            maxLength={32}
                            placeholder="Classroom de la materia"
                            autoComplete="false"
                            defaultValue={codigoClassroom}
                            onChange={onChangeText}
                          />
                        </div>
                      </div>
                    </th>
                  )
                }
              </tr>
              <tr>
                <th className="col col-6"><span>PRE-REQUISITOS({(preRequisitos || []).length}):</span></th>
              </tr>
            </thead>
            <tbody>
              {preRequisitos.map(({
                id, materia, semestreNro,
              }) => (
                <tr key={`preRequisitos-tr-${semestreNro}-${id}`} id={`preRequisitos-tr-${semestreNro}-${id}`}>
                  <th className="col col-2">
                    <div className="form" style={{ display: 'flex' }}>
                      <span>
                        {`${materia} `}
                        <Badge
                          key={`bg-${semestreNro}-${id}`}
                          color="primary"
                        >
                          {`${semestreNro}º`}
                        </Badge>
                      </span>
                    </div>
                  </th>
                </tr>
              ))}
            </tbody>
          </table>
        </Col>
      </Row>
    </div>
  );
};

HorariosTable.propTypes = {
  profesores: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  meta: PropTypes.shape({}),
  materiaPeriodo: PropTypes.shape({}).isRequired,
  codigoClassroom: PropTypes.string,
  onChangeText: PropTypes.func.isRequired,
  esAlumno: PropTypes.bool,
};

HorariosTable.defaultProps = {
  meta: {},
  codigoClassroom: '',
  esAlumno: false,
};

export default HorariosTable;
